<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <v-toolbar-title class="white--text">รายงานสติ๊กเกอร์จอดรถ</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md6 d-flex>
            <v-select
              :loading="loadingAcademicYear"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="params.academicYear"
              item-value="id"
              item-text="yearSemester"
              outline
              hide-details
              @change="active = true"
            ></v-select>
          </v-flex>
          
          <!-- <v-flex xs12 md3 d-flex>
            <v-menu
              ref="menuFromDate"
              :close-on-content-click="false"
              v-model="menuFromDate"
              :nudge-right="40"
              :return-value.sync="params.fromDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(params.fromDate)"
                label="ตั้งแต่วันที่"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="params.fromDate" @input="$refs.menuFromDate.save(params.fromDate)" no-title locale="th-Th"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-menu
              ref="menuToDate"
              :close-on-content-click="false"
              v-model="menuToDate"
              :nudge-right="40"
              :return-value.sync="params.toDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(params.toDate)"
                label="ถึงวันที่"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="params.toDate" @input="$refs.menuToDate.save(params.toDate)" no-title locale="th-Th"></v-date-picker>
            </v-menu>
          </v-flex> -->
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          target="_new" 
          :href="printoutUrl"
          v-if="active"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      active: false,
      disabled: true,
      loading: false,
      loadingAcademicYear: false,
      menuFromDate: false,
      menuToDate: false,
      academicYearItems: [],
      params: {
        academicYear: null,
        fromDate: null,
        toDate: null
      }
    }
  },
  mounted () {},
  computed: {
    ...mapGetters ({
      token: 'token'
    }),
    printoutUrl () {
      return `${config.serverURI}/parkingRequests/printout?academicYear=${this.params.academicYear}&fromDate=${this.params.fromDate}&toDate=${this.params.toDate}&access_token=${this.token}`
    }
  },
  mounted () {
    this.fetchAcademicYears ()
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    fetchAcademicYears () {
      this.loadingAcademicYear = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loadingAcademicYear = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYear = false
        })
    }
  },
  watch: {
    'params': {
      handler (val) {
       if( val.fromDate && val.toDate ) {
          let fd = moment(val.fromDate)
          let td = moment(val.toDate)
          if(td.diff(fd) < 0) this.params.fromDate = this.params.toDate
          this.active = true
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/requests/parking.vue